// API Base URL - automatisch je nach Environment
export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://ai-visibility-api-6g7jpdw4ua-oa.a.run.app'
  : 'http://localhost:5000';
export const APP_BASE_URL = '';
